<p-toast position="top-right"></p-toast>

<div>
	<div class="container mt-3">
		<fieldset>
			<legend>{{'SIGALE_ANGULAR.COMPONENTS.COMMUNICATION_UTILISATEUR.TITRE_SECTION' | translate }}</legend>
			<div class="communication-form">
				<hr *ngIf="!modeApplicationCohabitation">
				<div class="bouton-traduction">
					<button (click)="traduireMessage()"
							[disabled]="!peutTraduireMessage() || loadingTraduction"
							[label]="'SIGALE_ANGULAR.COMPONENTS.COMMUNICATION_UTILISATEUR.BTN_TRADUIRE' | translate"
							pButton
							type="button">
					</button>
					<div *ngIf="loadingTraduction" class="app-spinner"></div>
				</div>
				<div *ngIf="!loading" class="container-fluid">
					<div *ngFor="let messageLangue of messageParLangue; let index = index" class="row form-group">
						<label class="required" for="'obs' + index">{{ 'SIGALE_ANGULAR.COMPONENTS.COMMUNICATION_UTILISATEUR.LABEL_MESSAGE' | translate: {
							langue: messageLangue.langue.designation
						} }}</label>
						<textarea
								[(ngModel)]="messageLangue.message"
								id="'obs' + index"
								name="'obs' + index"
								required>
							</textarea>
					</div>
					<div class="row form-group">
						<label class="label-required color-selection">{{'SIGALE_ANGULAR.COMPONENTS.COMMUNICATION_UTILISATEUR.LABEL_COULEUR' | translate}}</label>
						<p-selectButton [(ngModel)]="couleurSelectionnee" [options]="couleursPossibles" required></p-selectButton>
					</div>
					<div class="row form-group boutons-communication-utilisateurs">
						<button (click)="enregistrerEtDiffuser(false)"
								[disabled]="!peutSupprimerOuDiffuser()"
								[label]="'SIGALE_ANGULAR.COMPONENTS.COMMUNICATION_UTILISATEUR.BTN_DIFFUSER' | translate"
								icon="icon-white icon-bullhorn fas fa-bullhorn"
								pButton
								title="{{'SIGALE_ANGULAR.COMPONENTS.COMMUNICATION_UTILISATEUR.TITLE_BTN_DIFFUSER' | translate}}"
								type="button">
						</button>
						<button (click)="enregistrerEtDiffuser(true)"
								[disabled]="!peutSupprimerOuDiffuser()"
								[label]="'SIGALE_ANGULAR.COMPONENTS.COMMUNICATION_UTILISATEUR.BTN_SUPPRIMER' | translate"
								class="ui-button-secondary"
								icon="icon-remove fas fa-times"
								pButton
								title="{{'SIGALE_ANGULAR.COMPONENTS.COMMUNICATION_UTILISATEUR.TITLE_BTN_SUPPRIMER' | translate}}"
								type="button">
						</button>
					</div>
				</div>
			</div>
			<div *ngIf="loading" class="app-spinner"></div>
		</fieldset>
	</div>
</div>
